"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function($log, $timeout) {
  var that = this;
  let inProgressSxSRequests = 0;
  let handshakePending = false;
  let waitFor = 3000;
  let retries = 10;
  const isSxSRequestPending = () => inProgressSxSRequests > 0;
  const isHandshakePending = () => handshakePending;
  const addInProgressRequest = () => inProgressSxSRequests++;
  const removeInProgressRequest = () => {
    if (inProgressSxSRequests > 0) {
      inProgressSxSRequests--;
    }
  };
  const setHandshakePending = () => (handshakePending = true);
  const setHandshakeComplete = () => (handshakePending = false);

  const wait = () => new Promise(resolve => $timeout(resolve, waitFor));

  const executeOrRejectIfBlocked = (
    actionDescription,
    isRequestPending,
    executeSxsRequest,
    executeAddRequestInProgress,
    executeRemoveRequestInProgress
  ) => () => {
    return new Promise((resolve, reject) => {
      if (!isRequestPending()) {
        $log.info(`executing ${actionDescription}...`);
        executeAddRequestInProgress();
        return resolve(
          executeSxsRequest().finally(() => {
            executeRemoveRequestInProgress();
          })
        );
      } else {
        const errorMessage = `${actionDescription} action blocked...`;
        $log.info(errorMessage);
        return reject(errorMessage);
      }
    });
  };

  const executeWithRetry = (executionAction, retries) => {
    return new Promise((resolve, reject) => {
      return executionAction()
        .then(resolve)
        .catch(errorMessage => {
          const retriesRemaining = retries - 1;
          $log.info(
            `${errorMessage} attempt remaining ${retriesRemaining}/${retries}`
          );
          if (retriesRemaining > 0) {
            return wait()
              .then(
                executeWithRetry.bind(null, executionAction, retriesRemaining)
              )
              .then(resolve)
              .catch(reject);
          } else {
            const error = `exhausted all attempts to execute. ${errorMessage}`;
            $log.error(error);
            return reject(error);
          }
        });
    });
  };

  that.executeSideBySideRequest = (executeSxsRequest, actionDescription) => {
    const executeSxSAction = executeOrRejectIfBlocked(
      actionDescription,
      isHandshakePending,
      executeSxsRequest,
      addInProgressRequest,
      removeInProgressRequest
    );
    return executeWithRetry(executeSxSAction, retries).then(
      sxsRequestResult => {
        $log.debug(
          `execute SxS request: ${actionDescription} : result:[${sxsRequestResult}]`
        );
        return sxsRequestResult;
      }
    );
  };

  that.executeHandshake = handshakeRequest => {
    const actionDescription = "handshake Request";
    const executeHandshakeAction = executeOrRejectIfBlocked(
      actionDescription,
      isSxSRequestPending,
      handshakeRequest,
      setHandshakePending,
      setHandshakeComplete
    );

    return executeWithRetry(executeHandshakeAction, retries).then(
      handshakeResult => {
        $log.debug(
          `execute SxS request: ${actionDescription} : result:[${handshakeResult}]`
        );
        return handshakeResult;
      }
    );
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/sideBySideRequestGateway.js